import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { fetchSportsRequest } from '@/api/sports';
import { tryFetchSports, fetchSports, setSports } from '../actions';
import { sports } from '../selectors';

const tryFetchSportsEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchSports.match),
    withLatestFrom(state$),
    map(([, state]) => {
      const currentSports = sports(state);

      if (currentSports?.length) {
        return { type: 'SPORTS_ALREADY_FETCHED' };
      }

      return fetchSports();
    }),
  );

const fetchSportsEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchSports.match),
    request(() => fetchSportsRequest(), fetchSports),
  );

const fetchSportsSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchSports.succeeded.match),
    map(({ payload: { data } }) => setSports(data)),
  );

export default combineEpics(
  tryFetchSportsEpic,
  fetchSportsEpic,
  fetchSportsSucceededEpic,
);
